import { Card, Row, Spin } from "antd";
import { IntervalSelector } from "../IntervalSelector";
import { useMemo, useState } from "react";
import { useFormattedBalance } from "../../hooks/useFormattedBalance";
import { useFetchData } from "./hooks/useFetchData";
import { KPI_CODES } from "../../kpiCodes";
import AreaChart from "../AreaChart";

type PayoffAmountsProps = {
  isDataLoading: boolean;
  payoffAmounts: any;
  isRecalculated: boolean;
};

export const PayoffAmounts = ({
  isDataLoading,
  payoffAmounts,
  isRecalculated,
}: PayoffAmountsProps) => {
  const [granularity, setGranularity] = useState<number>(2);

  const { getFormattedBalance } = useFormattedBalance();

  const codes: string[] = useMemo(
    () => [
      KPI_CODES.PAYOFF_COUNT_TODAY,
      KPI_CODES.PAYOFF_COUNT_THIS_MONTH,
      KPI_CODES.PAYMENTS_THIS_YEAR,
    ],
    [],
  );

  const { isLoading, data } = useFetchData(
    granularity,
    isRecalculated,
    codes,
    "Payoff Amount",
  );

  return (
    <Card className="dashboard-card top">
      <Row className="w-100 justify-space-between">
        <p className="text my-0">Payoff Amounts</p>
        <IntervalSelector value={granularity} onSelect={setGranularity} />
      </Row>
      <Row className="d-block h-100">
        {!isDataLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <Row className="d-block mr-6">
                <h3 className="h h3">
                  {getFormattedBalance(payoffAmounts[granularity])}
                </h3>
                <p className="my-0 text-sm title">total payoffs</p>
              </Row>
            </Row>
            <AreaChart data={data} isLoading={isLoading} isAmout />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};
